import { PayPalButtons } from '@paypal/react-paypal-js';
import React from 'react';
import { globalActions } from '../../store/global';
import { useDispatch } from 'react-redux';

function PayPalButton({ amount, onPaymentError, onPaymentApprove }) {
  const dispatch = useDispatch();

  //* onApprove RESPONSE sample>>
  //  data= {
  // "orderID": "2LP588141H9059927",
  // "payerID": "2JDE6SPYX4GWY",
  // "paymentID": "2LP588141H9059927",
  // "billingToken": null,
  // "facilitatorAccessToken": "A21AALKXPTIkThN_Iy8GIWQI_wmu8C5a7IwdIqSWM22_uxvjOSgSaJyMAGdnpZFSlVyoevg5E3eSmwBhBthtenFu1e04lTmLg",
  // "paymentSource": "paypal"
  //   }

  const onApprove = (data, actions) => {
    return actions.order.capture().then((details) => {
      const payerName = details.payer.name.given_name;
      const status = details.status;
      const message = `Transaction completed by ${payerName}. Thank you for your purchase!`;
      dispatch(
        globalActions.setToaster({
          message: message,
          type: 'success',
        })
      );
      onPaymentApprove(data, status, message);
    });
  };

  const onError = (err) => {
    dispatch(
      globalActions.setToaster({
        message:
          typeof err === 'string'
            ? err
            : 'An unexpected error occurred. Please try again later.',
        type: 'error',
      })
    );

    onPaymentError(err, 'FAILED');
  };

  if (!amount) return;

  return (
    <PayPalButtons
      style={{ layout: 'vertical' }}
      createOrder={(data, actions) => {
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: amount,
              },
              shipping_preference: 'NO_SHIPPING',
            },
          ],
          application_context: {
            shipping_preference: 'NO_SHIPPING', // Ensure there is no shipping information
          },
        });
      }}
      onApprove={onApprove}
      onError={onError}
    />
  );
}

export default PayPalButton;
